import {ReactNode} from 'react'
import {Link} from 'react-router-dom'
import cn from 'clsx'

import styles from './Auth.module.scss'
// import logoImg from 'assets/images/logo.svg'
import logoImg from './Auth.logo.svg'
import {Paper, Back} from 'common/components'
import { Button } from 'common/components/V2'

interface AuthProps {
  children: ReactNode
  title?: string
  backTo?: string
  footerTo?: string
  func?: 'login' | 'sign-up'
}

export default function Auth({children, title, backTo, footerTo, func}: AuthProps) {
  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        <img
          // className={styles.logo}
          // width={142}
          // height={108}
          src={logoImg}
          alt="VC Online"
        />
        { (func === 'login') &&
          <Link to='/sign-up'>
            <Button $size='small' $color='cyan' >Sign up</Button>
          </Link>
        }
        { (func === 'sign-up') &&
          <Link to='/login'>
            <Button $size='small' $color='cyan' >Login</Button>
          </Link>
        }
        
      </div>
      <div className={styles.root}>
        {/* <img
          className={styles.logo}
          width={142}
          height={108}
          src={logoImg}
          alt="VC Online"
        /> */}
        <Paper className={cn(styles.paper, (func === 'login') ? styles.transparent : undefined)}>
          {backTo && <Back to="/login" />}
          {title && <h1 className={styles.title}>{title}</h1>}
          {children}
        </Paper>
        {footerTo && <Footer to={footerTo} />}
      </div>
    </div>
  )
}

interface FooterProps {
  to: string
}
const Footer = ({to}: FooterProps) => {
  const isLogin = to.endsWith('sign-up')
  return (
    <footer className={styles.footer}>
      {isLogin ? 'Do not' : 'Already'} have an account?
      <Link className={styles.link} to={to}>
        {isLogin ? 'Sign up' : 'Log in'}
      </Link>
    </footer>
  )
}
